import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GithubAuthProvider, signInWithRedirect } from "firebase/auth";
import { getFirebaseAuth } from "@vertesia/ui/session";
import { Button } from "@vertesia/ui/core";
import { useUITranslation } from "@vertesia/ui/i18n";
export default function GitHubSignInButton({}) {
    const { t } = useUITranslation();
    const signIn = () => {
        localStorage.removeItem("tenantName");
        const provider = new GithubAuthProvider();
        provider.addScope("profile");
        provider.addScope("email");
        /*provider.setCustomParameters({
            redirect_uri: redirectPath,
        });*/
        signInWithRedirect(getFirebaseAuth(), provider);
    };
    return (_jsxs(Button, { variant: "outline", onClick: signIn, className: "w-full py-5 flex rounded-lg hover:shadow-sm transition duration-150 text-center mb-2", children: [_jsx("img", { className: "size-6 bg-white rounded-full", src: "https://www.svgrepo.com/show/503359/github.svg", loading: "lazy", alt: "github logo" }), _jsx("span", { className: "text-sm font-semibold", children: t('auth.continueWithGithub') })] }));
}
//# sourceMappingURL=GitHubSignInButton.js.map